import { network } from 'services/network';

export const reorderRankForStoredFilterBulkAssignToUser = (params) => {
    return network.post('api/bo/reorderRankForStoredFilterBulkAssignToUser', params).then((response) => response.data);
};
